import {gsap} from "gsap/all";
import $ from "jquery";

// This will use the same template as the one in the main app
const CALLER = `{% from "templates/cbms/components/notification.twig.html" import notification %}{{ notification(data) }}`;

export class Notification {
  constructor($container, data) {
    this.$container = $container;
    this.data = data;
    this.$el = null;
  }

  render({prepend = false} = {}) {
    return new Promise((resolve, reject) => {
      app.nunjuckEnv.renderString(CALLER, {data: this.data}, (err, html) => {
        if (err) return reject(err);
        this.$el = $(html.trim());
        if (prepend) this.$container.prepend(this.$el);
        else this.$container.append(this.$el);

        app.audio.play("audio/Notification1.wav", 1, true);

        resolve(this);
      });
    });
  }

  setShown(shown, {instant = false} = {}) {
    if (!this.$el) return;
    const $info = this.$el.find(".info-container .info");
    if (shown) {
      this.$el.addClass("shown");
      let maxHeight = 0;
      $info.find("span").each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });
      if (instant) gsap.set($info, {height: maxHeight});
      else gsap.to($info, {height: maxHeight, duration: 0.25, ease: "power2.out"});
    } else {
      this.$el.removeClass("shown");
      if (instant) gsap.set($info, {height: 16});
      else gsap.to($info, {height: 16, duration: 0.25, ease: "power2.out"});
    }
  }

  show() {
    if (!this.$el) return;
    gsap.fromTo(this.$el, { opacity: 0, y: -16 }, { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" });
  }

  hide() {
    if (!this.$el) return;
    return new Promise((resolve) => {
      gsap.to(this.$el, { opacity: 0, y: -16, duration: 0.3, ease: "power2.in", onComplete: resolve });
    });
  }

  destroy() {
    if (this.$el) {
      gsap.killTweensOf(this.$el);
      gsap.killTweensOf(this.$el.find(".info-container .info"));
      this.$el.remove();
    }
    this.$el = null;
  }
}
